/* eslint-disable consistent-return */

import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
  const fullPath = to.fullPath?.toString()

  if (fullPath.includes('listings/missing-infos')) {
    return navigateTo(fullPath.replaceAll('missing-infos', ''))
  }

  if (fullPath.includes('listings-new')) {
    return navigateTo(fullPath.replaceAll('listings-new', 'listings'))
  }
})
